// extracted by mini-css-extract-plugin
export var measureBox = "_bf-0";